export const TICKET_URL = "https://www.tixforgigs.com/Location/1419";
